import React, { Component } from 'react';
import {connect} from 'react-redux';
import {cekCookies} from '../../../../actions';
import { CONFIG } from '../../../../config';
import __ from 'lodash';
import accountManagement from '../../../../apis/accountManagement';
import filterReportDinasAgcu from '../../../../entity/FilterReportDinasAgcu';
import { Row, Col } from 'react-bootstrap';
import Loader from '../../../Loader';
// import LoaderModal from '../../../modal/LoaderModal';
import Alert from '@material-ui/lab/Alert';
import IconButton from '@material-ui/core/IconButton';
import logo_eduprime from '../homework/images/eduprime_tulisan_hitam.png';
import logo_agcu from './images/logo_agcu.png';

class ReportDinasAgcuPreview extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            isFetching: false,
            isLoading: false,
            dialogShow: false,
            alertShow: false,
            alertMessage: '',
            idAdmin: null,
            idProvinsi: null,
            idDinas: null,
            namaDinas: null,
            idKelas: null,
            idProfilCbt: null,
            namaProfilCbtSelected: null,
            dataMapel: [],
            dataRataStatistik: [],
            dataRataSekolah: [],
            dataRataPerSekolah: [],
            dataSekolahDinas: [],
            dataLS: [],
            dataPSI: [],
            result: [],
            dataSatuanPend: null,
            dataJumAllSiswa: null,
        };
    }

    async componentDidMount() {
        document.title = "Priview AGCU Dinas";
        console.clear();
        console.time("Time componentDidMount");
        this.setState({
            isFetching: true,
            idKelas: this.props.match.params.idKelas,
            idProfilCbt: this.props.match.params.idProfilCbt
        });
        await this.props.cekCookies();

        console.groupCollapsed('componentDidMount');
        console.info('CEK ACCOUNT', this.props.account);
        console.info('PARAM 1',  this.state.idKelas);
        console.info('PARAM 2',  this.state.idProfilCbt);
        console.groupEnd();
        
        if(!__.isEmpty(this.props.account)) {
            this.setState({
                idAdmin: this.props.account.idAdmin,
                idProvinsi: this.props.account.idProvinsi,
                idDinas: this.props.account.idDinas,
                namaDinas: this.props.account.namaUser,
            });

            const result = await accountManagement.post(CONFIG.REPORT_DINAS_AGCU_NEW_LIST, {...filterReportDinasAgcu,
                idKelas: this.state.idKelas,
                idProfilCbt: this.state.idProfilCbt,
                typeReport: 'AGCU',
            }).catch(function(error) {
                console.error('ERROR fetchReportDinasAgcu', error);
            });
            console.info('Response fetchReportAgcuPreview', result);
            
            if (result) {
                if(result.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                    this.setState({
                        // result: result.data.data,
                        dataMapel: result.data.data.mapel,
                        dataRataStatistik: result.data.data.rataStatistik,
                        dataRataSekolah: result.data.data.rataSekolah,
                        dataRataPerSekolah: result.data.data.rataPerSekolah,
                        dataSekolahDinas: result.data.data.sekolahDinas,
                        dataSatuanPend: result.data.data.satuanPendidikan,
                        dataJumAllSiswa: result.data.data.jumAllSiswa,
                        dataLS: result.data.data.LS,
                        dataPSI: result.data.data.PSI,
                        dataDominasiLS: result.data.data.dominasiLS,
                        isFetching: false
                    });
                }
                else {
                    this.setState({
                        showAlert: true,
                        resMessage: result.data.errorSchema.errorMessage,
                        isFetching: false
                    });
                }
            }
        }

        this.setState({
            isFetching: false
        });
        console.timeEnd("Time componentDidMount");
    }

    loading = () => {
        if(this.state.isLoading) {
            return(
                <Loader />
            )
        }
    }

    showAlert = () => {
        if(this.state.alertShow) {
            return(
                <Alert severity="info"
                    action={
                        <IconButton
                        aria-label="close"
                        color="inherit"
                        size="small"
                        onClick={() => this.setState({alertShow:false})}
                        >
                        <i class="fa fa-times" aria-hidden="true"></i>
                        </IconButton>
                    }
                    >
                    <strong>{this.state.alertMessage}</strong>
                </Alert>
            )
        }
    }

    renderJudulMapel() {
        return (
            <thead>
                <th scope="col" style={{ textAlign: 'center' }}>NO</th>
                <th scope="col" style={{ textAlign: 'center' }}>SEKOLAH</th>
                <th scope="col" style={{ textAlign: 'center' }}>JUMLAH SISWA</th>
                {
                    this.state.dataMapel.map((val, index) => {
                        return (
                            <th scope="col" key={val.ID_MATA_PELAJARAN} data-attr-key={val.ID_MATA_PELAJARAN} style={{ textAlign: 'center' }}>{ val.NAMA_MATA_PELAJARAN }</th>
                        )
                    })
                }
                <th scope="col" style={{ textAlign: 'center' }}>RATA - RATA</th>
            </thead>
        )
    }

    renderIsiSekolah() {
        return (
            <tbody>
                {
                    this.state.dataSekolahDinas.map((itemDinas, indexDinas) => {
                        return (
                            <tr key={itemDinas.ID_SEKOLAH} data-attr-id-sekolah={itemDinas.ID_SEKOLAH} data-attr-index={indexDinas + 1}>
                                <td key={itemDinas.ID_SEKOLAH} data-attr-index={indexDinas + 1} style={{ textAlign: 'center' }}>{ indexDinas + 1 }</td>
                                <td key={itemDinas.ID_SEKOLAH} data-attr-nama-sekolah={itemDinas.NAMA_SEKOLAH}>{ itemDinas.NAMA_SEKOLAH }</td>
                                <td key={itemDinas.ID_SEKOLAH} data-attr-jumlah-siswa={itemDinas.JUMLAH_SISWA} style={{ textAlign: 'center' }}>{ parseInt(itemDinas.JUMLAH_SISWA) }</td>
                                {
                                    this.state.dataRataSekolah.map((itemSekolah, indexSekolah) => {
                                        if(itemDinas.ID_SEKOLAH === itemSekolah.ID_SEKOLAH) {
                                            return this.state.dataMapel.map((itemMapel, indexMapel) => {
                                                if(itemMapel.ID_MATA_PELAJARAN === itemSekolah.ID_MAPEL) {
                                                    return (    
                                                        <td key={itemDinas.ID_SEKOLAH} data-attr-idmapel={itemMapel.ID_MATA_PELAJARAN} style={{ textAlign: 'center' }}>{ parseFloat(itemSekolah.NILAI_RATA_RATA_MAPEL).toFixed(2) }</td>
                                                    )
                                                }
                                            });
                                        }
                                    })
                                }
                                {
                                    this.state.dataRataPerSekolah.map((itemPerSekolah, indexPerSekolah) => {
                                        if(itemDinas.ID_SEKOLAH === itemPerSekolah.ID_SEKOLAH) {
                                            return (
                                                <td key={itemDinas.ID_SEKOLAH} data-attr-idmapel={itemPerSekolah.ID_SEKOLAH} style={{ textAlign: 'center' }}>{ parseFloat(itemPerSekolah.NILAI_RATA_RATA_SEKOLAH).toFixed(2) }</td>
                                            )
                                        }
                                    })
                                }
                            </tr>
                        )
                    })
                }
            </tbody>
        );
    }

    renderJudulTable_2() {
        return (
            <thead>
                <tr>
                    <th scope="col" rowspan="2" style={{ verticalAlign: 'inherit', textAlign: 'center' }}>STATISTIKA</th>
                    <th scope="col" colspan={ this.state.dataMapel.length } style={{ verticalAlign: 'inherit', textAlign: 'center' }}>MATA PELAJARAN</th>
                    <th scope="col" rowspan="2" style={{ verticalAlign: 'inherit', textAlign: 'center' }}>RATA - RATA</th>
                </tr>
                <tr>
                    {
                        this.state.dataMapel.map(function(valMapel) {
                            return (
                                <th scope="col" key={valMapel.ID_MATA_PELAJARAN} data-attr-key={valMapel.ID_MATA_PELAJARAN} style={{ textAlign: 'center' }}>{ valMapel.NAMA_MATA_PELAJARAN }</th>
                            )
                        })
                    }
                </tr>
            </thead>
        );
    }

    renderTbodyTable_2() {
        let kategori;
        let nilai;

        const sumKategoriRata = this.state.dataRataStatistik.reduce((totalKategori, valRataStatistik) =>
            {
                if (valRataStatistik.kategori === 'BAIK') {
                    nilai = 3;
                }
                else if (valRataStatistik.kategori === 'CUKUP') {
                    nilai = 2;
                }
                else {
                    nilai = 1;
                }

                return totalKategori + parseFloat(nilai, 0)
            }
        , 0);

        console.groupCollapsed('CEK');
        console.info('SUM STRING', sumKategoriRata);
        console.info('RATA - RATA STRING', parseInt(sumKategoriRata / this.state.dataRataStatistik.length));
        console.groupEnd();

        const rataKategori = parseInt(sumKategoriRata / this.state.dataMapel.length);
        if (rataKategori === 3) {
            kategori = <td style={{ color: '#0d9400', textAlign: 'center' }}>BAIK</td>;
        }
        else if (rataKategori === 2) {
            kategori = <td style={{ color: '#ccc508', textAlign: 'center' }}>CUKUP</td>;
        }
        else {
            kategori = <td style={{ color: '#ff0000', textAlign: 'center' }}>KURANG</td>;
        }

        return (
            <tbody>
                <tr data-attr="kategori">
                    <td>KATEGORI</td>
                    {
                        this.state.dataRataStatistik.map(function(valRataStatistik, indexRataStatistik) {
                            if (valRataStatistik.kategori === 'BAIK') {
                                return (
                                    <td key={valRataStatistik.idMapel} style={{ color: '#0d9400', textAlign: 'center' }}>{ valRataStatistik.kategori }</td>
                                )
                            }
                            else if (valRataStatistik.kategori === 'CUKUP') {
                                return (
                                    <td key={valRataStatistik.idMapel} style={{ color: '#ccc508', textAlign: 'center' }}>{ valRataStatistik.kategori }</td>
                                )
                            }
                            else {
                                return (
                                    <td key={valRataStatistik.idMapel} style={{ color: '#ff0000', textAlign: 'center' }}>{ valRataStatistik.kategori }</td>
                                )
                            }
                        })
                    }
                    {kategori}
                </tr>
                <tr data-attr="rata-rata">
                    <td>RATA - RATA</td>
                    {
                        this.state.dataRataStatistik.map(function(valRataStatistik, indexRataStatistik) {
                            return (
                                <td key={valRataStatistik.idMapel} style={{ textAlign: 'center' }}>{ parseFloat(valRataStatistik.rataNilai).toFixed(2) }</td>
                            )
                        })
                    }
                    <td style={{ textAlign: 'center' }}>
                        {
                            (this.state.dataRataStatistik.reduce((totalCalories, valRataStatistik) => totalCalories + parseFloat(valRataStatistik.rataNilai, 0), 0) / this.state.dataMapel.length).toFixed(2)
                        }
                    </td>
                </tr>
                <tr data-attr="terendah">
                    <td>TERENDAH</td>
                    {
                        this.state.dataRataStatistik.map(function(valRataStatistik, indexRataStatistik) {
                            return (
                                <td key={valRataStatistik.idMapel} style={{ textAlign: 'center' }}>{ parseFloat(valRataStatistik.nilaiRendah).toFixed(2) }</td>
                            )
                        })
                    }
                    <td style={{ textAlign: 'center' }}>
                        {
                            (this.state.dataRataStatistik.reduce((totalCalories, valRataStatistik) => totalCalories + parseFloat(valRataStatistik.nilaiRendah, 0), 0) / this.state.dataMapel.length).toFixed(2)
                        }
                    </td>
                </tr>
                <tr data-attr="tertinggi">
                    <td>TERTINGGI</td>
                    {
                        this.state.dataRataStatistik.map(function(valRataStatistik, indexRataStatistik) {
                            return (
                                <td key={valRataStatistik.idMapel} style={{ textAlign: 'center' }}>{ parseFloat(valRataStatistik.nilaiAtas).toFixed(2) }</td>
                            )
                        })
                    }
                    <td style={{ textAlign: 'center' }}>
                        {
                            (this.state.dataRataStatistik.reduce((totalCalories, valRataStatistik) => totalCalories + parseFloat(valRataStatistik.nilaiAtas, 0), 0) / this.state.dataMapel.length).toFixed(2)
                        }
                    </td>
                </tr>
                <tr data-attr="standart-deviasi">
                    <td>STANDAR DEVIASI</td>
                    {
                        this.state.dataRataStatistik.map(function(valRataStatistik, indexRataStatistik) {
                            return (
                                <td key={valRataStatistik.idMapel} style={{ textAlign: 'center' }}>{ parseFloat(valRataStatistik.stDev).toFixed(2) }</td>
                            )
                        })
                    }
                    <td style={{ textAlign: 'center' }}>
                        {
                            (this.state.dataRataStatistik.reduce((totalCalories, valRataStatistik) => totalCalories + parseFloat(valRataStatistik.stDev, 0), 0) / this.state.dataMapel.length).toFixed(2)
                        }
                    </td>
                </tr>
            </tbody>
        )
    }

    renderTbodyTable_3() {
        return (
            <tbody>
                { 
                    this.state.dataSekolahDinas.map((dataDinas, indexDinas) => {
                        return (
                            <tr key={dataDinas.ID_SEKOLAH} data-attr-idSekolah={dataDinas.ID_SEKOLAH}>
                                <td style={{ textAlign: 'center' }}>{ indexDinas + 1 }</td>
                                <td>{ dataDinas.NAMA_SEKOLAH }</td>
                                <td style={{ textAlign: 'center' }}>{ parseInt(dataDinas.JUMLAH_SISWA) }</td>
                                {
                                    this.state.dataLS.map((dataLS, indexLS) => {
                                        if (dataLS.ID_SEKOLAH === dataDinas.ID_SEKOLAH ) {
                                            return (
                                                <>
                                                    <td style={{ textAlign: 'center' }}>{ parseInt(dataLS.VISUAL) }</td>
                                                    <td style={{ textAlign: 'center' }}>{ parseInt(dataLS.AUDITORI) }</td>
                                                    <td style={{ textAlign: 'center' }}>{ parseInt(dataLS.KINESTETIK) }</td>
                                                </>
                                            )
                                        }
                                    })
                                }
                            </tr>
                        )
                    })
                }
            </tbody>
        )
    }

    renderTheadTable_4() {
        return (
            <thead>
                <tr>
                    <th rowspan="2" style={{ verticalAlign: 'inherit', textAlign: 'center' }}>NO</th>
                    <th rowspan="2" style={{ verticalAlign: 'inherit', textAlign: 'center' }}>SEKOLAH</th>
                    <th rowspan="2" style={{ verticalAlign: 'inherit', textAlign: 'center' }}>JUMLAH SISWA</th>
                    <th colspan="3" style={{ textAlign: 'center' }}>ADVERSTY QUOTIENT</th>
                    <th colspan="3" style={{ textAlign: 'center' }}>EMOTIONAL QUOTIENT</th>
                    <th colspan="3" style={{ textAlign: 'center' }}>ACHIEVEMENT MOTIVATION</th>
                </tr>
                <tr>
                    <th style={{ textAlign: 'center' }}>RATA BAWAH</th>
                    <th style={{ textAlign: 'center' }}>RATA - RATA</th>
                    <th style={{ textAlign: 'center' }}>RATA - ATAS</th>
                    <th style={{ textAlign: 'center' }}>RATA BAWAH</th>
                    <th style={{ textAlign: 'center' }}>RATA - RATA</th>
                    <th style={{ textAlign: 'center' }}>RATA - ATAS</th>
                    <th style={{ textAlign: 'center' }}>RATA BAWAH</th>
                    <th style={{ textAlign: 'center' }}>RATA - RATA</th>
                    <th style={{ textAlign: 'center' }}>RATA - ATAS</th>
                </tr>
            </thead>
        )
    }

    renderTbodyTable_4() {
        return (
            <tbody>
                {
                    this.state.dataPSI.map(function(valPSI, indexPSI) {
                        return (
                            <tr key={valPSI.ID_SEKOLAH} data-attr={valPSI.ID_SEKOLAH}>
                                <td style={{ textAlign: 'center' }}>{ indexPSI + 1 }</td>
                                <td>{ valPSI.NAMA_SEKOLAH }</td>
                                <td style={{ textAlign: 'center' }}>{ valPSI.JUMLAH_SISWA }</td>
                                <td style={{ textAlign: 'center' }}>{ valPSI.AQA }</td>
                                <td style={{ textAlign: 'center' }}>{ valPSI.AQB }</td>
                                <td style={{ textAlign: 'center' }}>{ valPSI.AQT }</td>
                                <td style={{ textAlign: 'center' }}>{ valPSI.EQA }</td>
                                <td style={{ textAlign: 'center' }}>{ valPSI.AMA }</td>
                                <td style={{ textAlign: 'center' }}>{ valPSI.AMB }</td>
                                <td style={{ textAlign: 'center' }}>{ valPSI.EQB }</td>
                                <td style={{ textAlign: 'center' }}>{ valPSI.AMT }</td>
                                <td style={{ textAlign: 'center' }}>{ valPSI.EQT }</td>
                            </tr>
                        )
                    })
                }
            </tbody>
        )
    }

    grapMapel() {
        return (
            <>
                {
                    this.state.dataRataStatistik.map((valRataStatistik, indexRataStatistik) => {
                        return (
                            <div className="row" key={valRataStatistik.idMapel}>
                                <Col sm={10} data-attr={valRataStatistik.idMapel}>
                                    <div className="detail_header_grapmapel">{ valRataStatistik.namaMapel }</div>
                                    <div class="graph">
                                        <div class="skills background" style={{ width: parseFloat(valRataStatistik.rataNilai).toFixed(2) + '%' }}></div>
                                    </div>
                                </Col>

                                <Col sm={2}>
                                    <div>&nbsp;</div>
                                    <div>{ parseFloat(valRataStatistik.rataNilai).toFixed(2) + '%'}</div>
                                </Col>
                            </div>
                        )
                    })
                }
            </>
        )
    }

    grapSekolah() {
        return this.state.dataSekolahDinas.map((valDinas, indexDinas) => {
            return (
                <>
                    {
                        this.state.dataRataPerSekolah.map((valSekolah, indexSekolah) => {
                            if(valDinas.ID_SEKOLAH === valSekolah.ID_SEKOLAH) {
                                return (
                                    <div className="row" key={valSekolah.ID_SEKOLAH} data-attr-idSekolah={valSekolah.ID_SEKOLAH}>
                                        <Col sm={10}>
                                            <div className="detail_header_grapmapel">{ valDinas.NAMA_SEKOLAH }</div>
                                            <div class="graph">
                                                <div class="skills background" style={{ width: parseFloat(valSekolah.NILAI_RATA_RATA_SEKOLAH).toFixed(2) + '%' }}></div>
                                            </div>
                                        </Col>

                                        <Col className="col-sm-2 col-sm-2" style={{ alignSelf: 'flex-end' }}>
                                            {/* <div>&nbsp;</div> */}
                                            <div className="center">{ parseFloat(valSekolah.NILAI_RATA_RATA_SEKOLAH).toFixed(2) + '%'}</div>
                                        </Col>
                                    </div>
                                );
                            }
                        })
                    }
                </>
            );
        });
    }
    
    render() {
        require('./report-custom.css');
        console.groupCollapsed('Render Cek State/Props ReportAgcuPreview');
        console.log('STATE', this.state);
        console.log('PROPS', this.props);
        console.groupEnd();

        const mystyle = {
            border: '3px solid grey',
            borderRadius: '1.50rem!important',
            margin: 'auto',
            width: '50%',
            height: '190px',
            textAlign: 'center',
        }

        return (
            <>
                {
                    this.state.idKelas !== null && this.state.idProfilCbt !== null
                    &&
                    <div id="dataToPrint">
                            {
                                this.state.dataMapel.length > 0
                                &&
                                <div>
                                    
                                    <Row className="header">
                                        <div class="col-sm-8">
                                            <h1 class="judul">
                                                <p class="judul-atas">ACADEMIC GENERAL CHECK UP</p>
                                                <p class="judul-bawah">ASSESSMENT REPORT</p>
                                            </h1>
                                        </div>
                
                                        <div class="col-sm-4">
                                            <div class="judul-img">
                                                <img class="judul-img" src={logo_eduprime}></img>
                                                <img class="judul-img" src={logo_agcu}></img>
                                            </div>
                                        </div>
                                    </Row>

                                    <h2 class="header-red mb10">&nbsp;</h2>

                                    <Row>
                                        <Col sm>
                                            <h5 className="detail_report">{ this.state.namaDinas }</h5>
                                        </Col>
                                        
                                        <Col sm>
                                            <h5>{ this.props.namaProfilCbt }</h5>
                                        </Col>
                                    </Row>

                                    <Row style={{ paddingTop: '15px' }}>
                                        <Col sm={12}>
                                            <h5 className="detail_table">RATA - RATA NILAI MATA PELAJARAN SEKOLAH</h5>
                                        </Col>

                                        <Col sm={12}>
                                            <table className="table table-custom">
                                                { this.renderJudulMapel() }

                                                { this.renderIsiSekolah() }
                                            </table>
                                        </Col>
                                    </Row>

                                    <Row style={{ paddingTop: '15px' }}>
                                        <Col sm={8}>
                                            <h5 className="detail_table">STATISTIK RATA - RATA NILAI MATA PELAJARAN</h5>
                                        </Col>
                                        <Col sm={4}>
                                            <h5 className="detail_table">GRAFIK RATA - RATA NILAI MATA PELAJARAN</h5>
                                        </Col>

                                        <Col sm={2} className="detail_table_child">SATUAN PENDIDIKAN</Col>
                                        <Col sm={2} className="detail_table_child">{ parseInt(this.state.dataSatuanPend) }</Col>
                                        <Col sm={4}>&nbsp;</Col>
                                        <Col sm={4}>&nbsp;</Col>

                                        <Col sm={2} className="detail_table_child">JUMLAH PESERTA</Col>
                                        <Col sm={2} className="detail_table_child">{ parseInt(this.state.dataJumAllSiswa) }</Col>
                                        <Col sm={4}>&nbsp;</Col>
                                        <Col sm={4}>&nbsp;</Col>

                                        <Col sm={8}>
                                            <table className="table table-custom">
                                                { this.renderJudulTable_2() }

                                                { this.renderTbodyTable_2() }
                                            </table>
                                        </Col>

                                        <Col sm={4}>
                                            { this.grapMapel() }
                                        </Col>
                                    </Row>

                                    <Row style={{ paddingTop: '15px' }}>
                                        <Col sm={10}>
                                            <h5 className="detail_table">GRAFIK RATA - RATA NILAI MATA PELAJARAN PER SEKOLAH</h5>
                                        </Col>
                                        <Col sm={2}>
                                            <h5 className="detail_table center">Nilai Rata - Rata</h5>
                                        </Col>

                                        <Col sm={12}>
                                            { this.grapSekolah() }
                                        </Col>
                                    </Row>

                                    <Row style={{ paddingTop: '15px' }}>
                                        <Col sm={9}>
                                            <h5 className="detail_table">PEMETAAN GAYA BELAJAR PER SEKOLAH</h5>
                                        </Col>

                                        <Col sm={9}>
                                            <table className="table table-striped table-custom">
                                                <thead>
                                                    <th scope="col" style={{ textAlign: 'center' }}>NO</th>
                                                    <th scope="col" style={{ textAlign: 'center' }}>SEKOLAH</th>
                                                    <th scope="col" style={{ textAlign: 'center' }}>JUMLAH SISWA</th>
                                                    <th scope="col" style={{ textAlign: 'center' }}>VISUAL</th>
                                                    <th scope="col" style={{ textAlign: 'center' }}>AUDIO</th>
                                                    <th scope="col" style={{ textAlign: 'center' }}>KINESTETIK</th>
                                                </thead>

                                                { this.renderTbodyTable_3() }
                                            </table>
                                        </Col>

                                        <Col sm={3}>
                                            <h5 className="detail_table" style={{ textAlign: 'center' }}>DOMINASI</h5>
                                            <div className="border rounded center">{ this.props.dominasiLS }</div>
                                        </Col>
                                    </Row>

                                    <Row style={{ paddingTop: '15px' }}>
                                        <Col sm={12}>
                                            <h5 className="detail_table">PEMETAAN PSYCHOLOGI TEST</h5>
                                        </Col>
                    
                                        <Col sm={12}>
                                            <table className="table table-custom">
                                                { this.renderTheadTable_4() }
                    
                                                { this.renderTbodyTable_4() }
                                            </table>
                                        </Col>
                                    </Row>
                                
                                    {/*
                                    <Row style={{ paddingTop: '15px' }}>
                                        <Col className="border rounded center" sm={3} style={ mystyle }>RATA - RATA</Col>
                                        <Col className="border rounded center" sm={3} style={ mystyle }>RATA - RATA ATAS</Col>
                                        <Col className="border rounded center" sm={3} style={ mystyle }>RATA - RATA BAWAH</Col>
                                    </Row>

                                    <Row style={{ paddingTop: '15px' }}>
                                        <Col sm={3} className="center">ADVERSTY QUOTIENT</Col>
                                        <Col sm={3} className="center">EMOTIONAL QUOTIENT</Col>
                                        <Col sm={3} className="center">ACHIEVEMENT MOTIVATION</Col>
                                    </Row>
                                    */}
                                </div>
                            }
                        <div className="fixed_button">
                            <button className="btn btn-outline-dark btn133w pull-right" style={{ marginRight:'1em' }} onClick={() => window.print()}>Print</button>
                        </div>
                    </div>
                }
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        account: state.account
    };
}

export default connect(mapStateToProps, {cekCookies})(ReportDinasAgcuPreview); 